__turbopack_context__.v({
  "focusOption": "Recruiter-module__eY9wuW__focusOption",
  "focusOptionMuted": "Recruiter-module__eY9wuW__focusOptionMuted",
  "focusToggle": "Recruiter-module__eY9wuW__focusToggle",
  "imageColumn": "Recruiter-module__eY9wuW__imageColumn",
  "imageRow": "Recruiter-module__eY9wuW__imageRow",
  "note": "Recruiter-module__eY9wuW__note",
});
